import React, { useCallback, useEffect } from "react";
import { categoryApi } from "../../services/services";
import { Card, CardBody, CardHeader, CardTitle, Col, Row } from "reactstrap";
import CategoriesCards from "../components/CategoriesCards";



function Categories(props) {
    const [categories, setCategories] = React.useState([]);

    const getCategories = useCallback(async () => {
        const cat = await categoryApi()
        setCategories(cat?.data)
    })
    useEffect(() => {
        getCategories()
    }, [])

    return (
        <>
            <Col sm={12}>

                {categories && (
                    <Card className="card-chart ">
                        <CardHeader>
                            <Row>
                                <Col className="text-right font-weight-600" sm="6">
                                    <h5 className="card-category font-weight-600">دسته بندی</h5>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody className="justify-content-center">
                            <CategoriesCards onSelect={props.onSelect} data={categories} />
                        </CardBody>
                    </Card>
                )}
            </Col>
        </>
    );
}

export default Categories;
